<template>
  <div class="preferences-dialog">
    <SDialog v-model:open="modalVisibility">
      <SDialogContent
        data-cy="preferences-modal"
        class="!w-[560px] !max-w-[560px]"
        @escape-key-down.prevent
        @pointer-down-outside.prevent
        @focus-outside.prevent
        @open-auto-focus.prevent
      >
        <SDialogHeader>
          <SDialogTitle>{{ $t("preferences.title") }}</SDialogTitle>
        </SDialogHeader>
        <SystemInfo />
        <SSeparator />
        <UserInfo />
      </SDialogContent>
    </SDialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// helpers
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";

// constants
import { ModalStatus } from "@/constants/modal";

import SystemInfo from "./system-info/SystemInfo.vue";
import {
  SDialog,
  SDialogContent,
  SDialogHeader,
  SDialogTitle,
  SSeparator,
} from "@smeetz/ui-core";

export default defineComponent({
  name: "Preferences",
  components: {
    SystemInfo,
    SDialog,
    SDialogContent,
    SDialogHeader,
    SDialogTitle,
    SSeparator,
  },
  setup() {
    const modalVisibility = dialogVisibleForStatus(ModalStatus.Preferences);
    return {
      modalVisibility,
    };
  },
});
</script>

<style lang="scss"></style>
